import { Dialog, DialogContent, DialogProps, Typography } from '@mui/material'
import { Box } from '@mui/system'
import SVGPanBlock from 'assets/svgpanblock'
import React, { useState, useContext } from 'react'
import AddButton from '../AddButton'
import { AlertDialogContext } from 'hooks/AlertDialogContext'
import { isMalaysia } from 'utils/tenant'
interface AlertDialogProps {
  openDialog: boolean
}

const AlertDialog = () => {
  const { alertDialog, updateAlertDialog } = useContext(AlertDialogContext)
  const isMalaysiaStyle = isMalaysia()

  return (
    <Dialog
      fullWidth
      open={alertDialog.openDialog}
      maxWidth={isMalaysiaStyle ? 'xs' : 'sm'}
      PaperProps={{
        sx: isMalaysiaStyle ? malaysiaDialogPaperSx : undefined,
      }}
      sx={isMalaysiaStyle ? { ...malaysiaDialogRootSx, zIndex: 9999 } : { borderRadius: '12px', ml: 2, mr: 2, zIndex: 9999 }}
      id='alertdialog'
    >
      <DialogContent sx={isMalaysiaStyle ? malaysiaDialogContentSx : undefined}>
        <Box
          display='flex'
          alignItems='center'
          sx={isMalaysiaStyle ? malaysiaDialogBodySx : { flexDirection: 'column' }}
        >
          {!isMalaysiaStyle && <Box sx={{ mt: 4 }}></Box>}
          <Box sx={isMalaysiaStyle ? malaysiaIconWrapSx : undefined}>{alertDialog.midIcon}</Box>
          <Typography
            align='center'
            variant='h1'
            sx={isMalaysiaStyle ? malaysiaTitleSx : { mt: 3, width: '100%', overflowWrap: 'break-word' }}
          >
            {alertDialog.title}
          </Typography>
          <Typography
            align='center'
            variant='h3'
            sx={isMalaysiaStyle ? malaysiaSubTextSx : { mt: 1, width: '100%', overflowWrap: 'break-word' }}
          >
            {alertDialog.subText}
          </Typography>
          <AddButton
            buttonText={alertDialog.actionName}
            sx={isMalaysiaStyle ? malaysiaActionSx : { mt: 4, mb: 2 }}
            fullWidth
            onClick={alertDialog.onActionClick}
          />
        </Box>
      </DialogContent>
    </Dialog>
  )
}

const malaysiaFontFamily = '"Inter", "Roboto", sans-serif'

const malaysiaDialogRootSx = {
  '& .MuiBackdrop-root': {
    backgroundColor: 'rgba(0, 0, 0, 0.48)',
  },
}

const malaysiaDialogPaperSx = {
  width: { xs: 'calc(100% - 32px)', sm: '420px' },
  mx: '16px',
  borderRadius: '28px',
  backgroundColor: '#FFFFFF',
  color: '#171D1B',
  boxShadow: '0px 16px 32px rgba(0, 0, 0, 0.24)',
}

const malaysiaDialogContentSx = {
  px: { xs: '24px', sm: '28px' },
  pt: '34px',
  pb: '24px',
}

const malaysiaDialogBodySx = {
  flexDirection: 'column',
  width: '100%',
}

const malaysiaIconWrapSx = {
  width: '64px',
  height: '64px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  mb: '22px',
  '& svg': {
    width: '64px',
    height: '64px',
  },
}

const malaysiaTitleSx = {
  width: '100%',
  overflowWrap: 'break-word',
  color: '#171D1B',
  fontFamily: malaysiaFontFamily,
  fontSize: '22px',
  fontWeight: 600,
  lineHeight: '28px',
  letterSpacing: '0px',
}

const malaysiaSubTextSx = {
  mt: '12px',
  width: '100%',
  overflowWrap: 'break-word',
  color: '#3F4942',
  fontFamily: malaysiaFontFamily,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '24px',
  letterSpacing: '0.15px',
}

const malaysiaActionSx = {
  mt: '28px',
  mb: 0,
  minHeight: '48px',
  borderRadius: '24px',
  borderColor: '#4B662C',
  color: '#4B662C',
  fontFamily: malaysiaFontFamily,
  fontSize: '16px',
  fontWeight: 700,
  lineHeight: '24px',
  letterSpacing: '0.1px',
  textTransform: 'none',
  '&:hover': {
    borderColor: '#4B662C',
    backgroundColor: 'rgba(75, 102, 44, 0.08)',
  },
}

export default AlertDialog
